import { NavLink, Outlet } from "react-router-dom";
import { Receipt, ClockCounterClockwise, ChartLine, Gear } from "@phosphor-icons/react";

const TABS = [
  { to: "/fiscal/emit",    label: "Emissão",         icon: Receipt,               testid: "fiscal-tab-emit" },
  { to: "/fiscal/history", label: "Histórico",       icon: ClockCounterClockwise, testid: "fiscal-tab-history" },
  { to: "/fiscal/report",  label: "Relatório Mensal", icon: ChartLine,             testid: "fiscal-tab-report" },
  { to: "/fiscal/config",  label: "Configurações",   icon: Gear,                  testid: "fiscal-tab-config" },
];

export default function FiscalLayout() {
  return (
    <div className="min-h-full bg-white">
      <header className="border-b border-black bg-white sticky top-0 z-10">
        <div className="px-6 py-5">
          <div className="overline text-zinc-500 text-xs">MÓDULO</div>
          <h1 className="font-head font-black text-2xl md:text-3xl leading-none mt-1">Fiscal · NF-e</h1>
        </div>
        <nav className="flex gap-0 border-t border-black overflow-x-auto" data-testid="fiscal-tabs">
          {TABS.map((t) => {
            const Icon = t.icon;
            return (
              <NavLink
                key={t.to}
                to={t.to}
                data-testid={t.testid}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-5 py-3 border-r border-black text-sm font-medium whitespace-nowrap transition-colors ${
                    isActive ? "bg-black text-white" : "bg-white hover:bg-zinc-100"
                  }`
                }
              >
                <Icon size={16} weight="bold" />
                {t.label}
              </NavLink>
            );
          })}
        </nav>
      </header>
      <div className="p-4 md:p-6">
        <Outlet />
      </div>
    </div>
  );
}
